const LockerCardPositionInfo = ({ locker }) => (
  <>{locker.description ? locker.description : null}</>
);

export default LockerCardPositionInfo;
